export const rateCalculation = (value) => {
  switch (value) {
    case 50:
      return '9,90';
    case 75:
      return '12,90';
    case 100:
      return '15,90';
    case 150:
      return '21,90';
    case 200:
      return '30,90';
    case 250:
      return '32,90';
    case 350:
      return '34,90';
    case 500:
      return '44,90';
    default:
      return 'error';
  }
};

export const finalBalanceCalculation = (value) => {
  switch (value) {
    case 50:
      return '40,10';
    case 75:
      return '62,10';
    case 100:
      return '84,10';
    case 150:
      return '128,10';
    case 200:
      return '169,10';
    case 250:
      return '217,10';
    case 350:
      return '315,10';
    case 500:
      return '455,10';
    default:
      return 'error';
  }
};
